import { WidgetState } from '../../models/widget-state';
import { WidgetStateId } from '../../models/aliases';

import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';

// ---------------- //
// Widget State API //
// ---------------- //

export interface WidgetStateGetParams {
  baseUrl: string;
  stateId: WidgetStateId;
}

const MAX_RETRIES = 5;
export const paperFinderStateApi = createApi({
  reducerPath: 'paperFinder/widgetState',
  baseQuery: retry(fetchBaseQuery({ baseUrl: '' }), {
    maxRetries: MAX_RETRIES,
  }),
  endpoints: (build) => ({
    widgetState: build.query<WidgetState, WidgetStateGetParams>({
      query: ({ baseUrl, stateId }) => ({
        url: `${baseUrl}widgets/state/${encodeURI(stateId)}`,
      }),
    }),
  }),
});

export const loadWidgetState =
  paperFinderStateApi.endpoints.widgetState.initiate;
